// @ts-nocheck
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { BlockBorderProps, BlockParsedBaseProps } from "@store/Library/Components/Toolkit/Block/Block";
import { defaultBorderProps } from "@store/Library/Components/Toolkit/Block/defaultProps";
import { BlockVariantBaseProps, BlockVariantTypeProps } from "@store/Library/Components/Toolkit/Block/variant/base";
import { clearfixStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { blockContainerClearFixStyles } from "@store/Library/Components/Toolkit/Block/mixins";
/* Store Custom Code - End */

export interface BlockVariantBorderedBaseProps {
    border: BlockBorderProps;
}
export interface BlockVariantBorderedProps extends BlockVariantBaseProps, BlockVariantBorderedBaseProps {}

const typeProps: BlockVariantTypeProps<BlockVariantBorderedProps> = {
    defaultProps: {
        border: defaultBorderProps,
    },
    staticProps: {
        containerCss: css<BlockParsedBaseProps>`
            ${blockContainerClearFixStyles() /* Store Custom Code */}

            ${({ theme, variantProps, variantSide }) => {
                const { width, type, color } = variantProps.bordered.border;
                const _topStyles = `border-top: ${width} ${type} ${resolveColor(color, theme)};`;
                const _bottomStyles = `border-bottom: ${width} ${type} ${resolveColor(color, theme)};`;

                switch (variantSide) {
                    case "top":
                        return _topStyles;
                    case "bottom":
                        return _bottomStyles;
                    default:
                        return css`
                            ${_topStyles}
                            ${_bottomStyles}
                        `;
                }
            }}
        `,
    },
};

export default typeProps;
